import { client } from "./index";
import { vendor } from "../Constant/index";


export const getCart = () => client.get(`cart`,  { headers: {"authorization" : `Bearer ${localStorage.getItem('ownezzy-user-token')}`} });

export const addToCart = (payload) => client.post(`cart`,  payload, { headers: {"authorization" : `Bearer ${localStorage.getItem('ownezzy-user-token')}`} });

export const deleteCart = (payload) => client.post(`cart/deleteCart`,  payload, { headers: {"authorization" : `Bearer ${localStorage.getItem('ownezzy-user-token')}`} });


